import React, { useEffect, useState, useRef } from 'react';
import { Route, Switch, useRouteMatch, useLocation, useHistory } from 'react-router-dom';
import { Pivot, PivotItem, PivotLinkSize } from 'office-ui-fabric-react/lib/Pivot';
import AddDimensionListOverview from '../AddDimensionListOverview';
import AddDimensionListDetails from '../AddDimensionListDetails';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';
import styles from './AddDimensionList.style';

const AddDimensionList = () => {
  const { path, url } = useRouteMatch();
  const { pathname, listFormData } = useLocation();
  const history = useHistory();
  const [selectedKey, setSelectedKey] = useState('overview');
  const ref = useRef();

  useEffect(() => {
    if (pathname.includes('/details')) {
      setSelectedKey('details');
    } else {
      setSelectedKey('overview');
    }
  }, [pathname, ref]);

  return (
    <>
      <PageTitle>Create a List</PageTitle>

      <Main className={styles.tabsContent}>
        <Pivot
          className={styles.tabs}
          aria-label="Dimension List sections"
          linkSize={PivotLinkSize.large}
          selectedKey={selectedKey}
          focusZoneProps={{ shouldFocusOnMount: true }}
          onLinkClick={item => {
            const formData = pathname.includes('/details') ? listFormData : ref.current.values;
            history.push({
              pathname: item.props.href,
              listFormData: formData,
            });
          }}
        >
          <PivotItem headerText="Overview" itemKey="overview" href={url} />
          <PivotItem headerText="Details" itemKey="details" href={`${url}/details`} />
        </Pivot>

        <Switch>
          <Route exact path={path} component={() => <AddDimensionListOverview ref={ref} />} />
          <Route exact path={`${path}/details`} component={AddDimensionListDetails} />
        </Switch>
      </Main>
    </>
  );
};

export default AddDimensionList;
